import { Button, Flex, Typography } from '@iheartjane/reefer';
import type { AppMode } from '@iheartjane/types';

import { Security } from '../security';
import { CTAButton } from './ctaButton';

export const MESSAGE_ID = 'location-message';

interface Props {
  allowLocationReset: boolean;
  appMode: AppMode;
  appPartner: string;
  detecting: boolean;
  onEnterLocation: () => void;
  onLocationReset: () => void;
}

export const LocationQuestion = ({
  allowLocationReset,
  appPartner,
  detecting,
  appMode,
  onLocationReset,
  onEnterLocation,
}: Props) => {
  const message = 'Find products at stores near you';

  return (
    <Flex flexDirection="column" gap={24}>
      <Typography
        id={MESSAGE_ID}
        variant="header-bold"
        textAlign="center"
        aria-label={message}
        branded
        px={24}
      >
        {message}
      </Typography>

      <Flex flexDirection="column" gap={8}>
        <CTAButton
          detecting={detecting}
          onClick={onEnterLocation}
          text="Enter your location"
          aria-controls="search-results-summary-text"
        />
        {appMode === 'default' && allowLocationReset && (
          <Button
            full
            label="Clear location"
            onClick={onLocationReset}
            variant="secondary"
            branded
          />
        )}
      </Flex>

      <Security appPartner={appPartner} modal />
    </Flex>
  );
};
